import { Node } from 'prosemirror-model';
export function deleteSelection(state, dispatch, view) {
    if (state.selection.empty) {
      return false;
    }
    if (dispatch) {
      /* salvo gli attributi dell'ultimo nodo selezionato per poi riapplicarli nel
      caso venga cancellato tutto */
      const selectedNodeAttrs = state.selection.$from.parent.attrs;
      let tr = state.tr.deleteSelection();
      tr = tr.scrollIntoView();
      /* se il documento è vuoto applico gli attributi dell'ultimo nodo*/
      if (tr.doc.textContent === '') {
        tr.doc.descendants((node: Node, pos: number, parent: Node) => {
          tr.setNodeMarkup(pos, node.type, selectedNodeAttrs);
          /* Doesn't descend into a node when the callback returns false. */
          return true;
        });
      }
      dispatch(tr);
    }
    return true;
  }
